import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { SENTRY_DSN, ENABLE_SENTRY } from './secrets';

const configureSentry = () => {
  if (ENABLE_SENTRY) {
    Sentry.init({
      dsn: SENTRY_DSN,
      release: '360stories-viewer@' + process.env.npm_package_version,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 1.0,
    });
  }
};

export default configureSentry;
